import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import BasicAuth from './components/BasicAuth';
import Portfolio from './components/Portfolio';
import logo from './test.svg';
import './App.css';

const DefaultScreen = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
      <div>
        BODY
        <nav>
          NAV
        </nav>
        <section>
          MAIN
        </section>
      </div>
    </div>
  );
}

const MaintainPage = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>Maintenance Page</h1>
        <p>
          This is the maintenance page for system administration.
        </p>
      </header>
      <div>
        <nav>
          <a href="/">Home</a>
        </nav>
        <section>
          <h2>Maintenance Tools</h2>
          <p>Maintenance functionality goes here.</p>
        </section>
      </div>
    </div>
  );
}

const UnderConstructionPage = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          under construction
        </p>
      </header>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <Routes>
            <Route path="/" element={<UnderConstructionPage />} />
            <Route path="/dev" element={<DefaultScreen />} />
            <Route path="/maintain" element={<MaintainPage />} />
            <Route path="/construction" element={<UnderConstructionPage />} />
            <Route path="/portfolio/*" element={
              <BasicAuth>
                <Portfolio />
              </BasicAuth>
            } />
          </Routes>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
